import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';

export function deleteGroupsBulk(ids: number[]) {
    const q = CoreQuery.fromNamespace(EntitiesList.USER_GROUPS).path([
        EntitiesList.PERSONA,
        EntitiesList.USER_GROUP,
        EntitiesList.BULK,
    ]);

    return httpClientCoreQuery.post(q, ids);
}
